export var CERTIFICATE = "certificate";
export var CERTIFICATE_HISTORY = "certificate history";
export var CONSUMER_TYPE = "consumer";
export var SNAPSHOT = "snapshot";
export var TROUBLE_IN_GETTING_DATA = "trouble in getting data";
export var PAGE_NAMES = {
    VIEW: "view",
    EMPTY: "empty",
    API_FAIL: "API Fail",
};
export var DEFAULTS = {
    SUB_FUNCTION: "",
    PAGE_FUNCTION: "rewards",
    PAGE_NAME: "",
    SITE_IDENTIFIER: "vista",
    DEVICE: "<mobi/desk/tab>",
    PNL: "vista",
    CUSTOMER_TYPE: "consumer",
    PRODUCT: "generic",
    ERROR_MESSAGE: "",
    MESSAGE: "",
    PAGE_KIND: "rewards",
    CLIENT_NAME: "",
};
